import { RouteComponentProps, useParams } from "@reach/router";
import { Typography, Table, Col, Row, Button, Modal, Alert, Tag } from "antd";
import { observer } from "mobx-react-lite";
import moment from "moment";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  MultiversStatus,
  MultiversLog,
  MultiversOperations,
} from "../component/multivers";
import Cell from "../component/order/cell";
import { useStore, Sync } from "../store";

interface Props extends RouteComponentProps {}
const UserList = (props: Props) => {
  const [shownDetails, setShownDetails] = useState<Sync>();
  const { t } = useTranslation();
  const { multivers } = useStore();
  const { administrationId } = useParams();
  const administration = useMemo(
    () => multivers.administration(administrationId),
    [administrationId]
  );

  const showDetails = (sync: Sync) => () => {
    setShownDetails(sync);
  };
  const hideDetails = () => {
    setShownDetails(undefined);
  };

  const data = administration?.sync.docs.slice();
  const columns = [
    {
      title: t("Date"),
      dataIndex: "startAt",
      key: "startAt",
      sorter: true,
      defaultSortOrder: "descend" as const,
      render: (date: Date) => (
        <Cell
          data={{
            title: moment(date).format("LLL"),
          }}
        />
      ),
    },
    {
      title: t("Duration"),
      dataIndex: "duration",
      key: "duration",
      render: (_: any, sync: Sync) => sync.duration.humanize(),
    },
    {
      title: t("Operations"),
      dataIndex: "operations",
      key: "operations",
      render: (_: any, sync: Sync) => (
        <MultiversOperations operations={sync.operations} />
      ),
    },
    {
      title: t("Status"),
      dataIndex: "status",
      key: "status",
      sorter: (a: Sync, b: Sync) => a.status.localeCompare(b.status),
      render: (_: any, sync: Sync) => (
        <>
          <MultiversStatus status={sync.status} />
          {sync.hasError && <Tag color="error">{t("Error")}</Tag>}
        </>
      ),
    },
  ];

  const rowHandler = (sync: Sync) => ({
    onClick: showDetails(sync),
  });

  return (
    <>
      <Row>
        <Col flex="auto">
          <Typography.Title>{t("Multivers synchronisation")}</Typography.Title>
        </Col>
      </Row>
      <Table
        dataSource={data}
        columns={columns}
        rowKey="id"
        pagination={false}
        onRow={rowHandler}
      />
      <Modal
        title={t("Sync details")}
        visible={!!shownDetails}
        onCancel={hideDetails}
        footer={[
          <Button key="ok" type="primary" onClick={hideDetails}>
            Ok
          </Button>,
        ]}
      >
        {shownDetails && (
          <>
            {shownDetails.hasError && (
              <Alert message={shownDetails.error} type="error" />
            )}
            <MultiversLog log={shownDetails.log} onCancel={hideDetails} />
          </>
        )}
      </Modal>
    </>
  );
};

export default observer(UserList);
